import * as React from "react";
import { Link } from "react-router-dom";
import * as CONFIG from "../../config";
import css from "./Navbar.module.css";

export default function NavbarFallback() {
  return (
    <header className={css.navbar}>
      <Link to="/" className={css.logoLink}>
        <img
          className={css.logo}
          width="108"
          height="40"
          alt="Streamily home"
          src={CONFIG.SITE_LOGO}
        />
      </Link>
    </header>
  );
}

NavbarFallback.propTypes = {};
